import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";
import { formatCurrency } from "@core/utils/filter";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useProgressList() {
  // Use toast
  const toast = useToast();

  const refProgressListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: "project_progress_number", label: "編號", sortable: true },
    { key: "order_number", stickyColumn: true, label: "施工單號", sortable: true },
    { key: "project_name", label: "項目名稱"},
    { key: "project_address", label: "工程地址" },
    { key: "show_details", label: "工資及成本摘要", sortable: true },
    { key: "total_amount", label: "薪金支出", sortable: true, formatter: formatCurrency },
    { key: "pay_date", label: "支付日期" },
    { key: "modifier", label: "更新者" },
    { key: "created_at", label: "創建日期", sortable: true },
    { key: "approve_status", label: "狀態", sortable: true },
    { key: "actions", label: "操作" },
  ];
  const perPage = ref(10);
  const totalRow = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);


  const dataMeta = computed(() => {
    const localItemsCount = refProgressListTable.value
      ? refProgressListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRow.value,
    };
  });

  const refetchData = () => {
    refProgressListTable.value.refresh();
  };


  const progressList = ref(null);

  const filter_project_progress_status_id = ref(null)
  
  watch(
    [currentPage, perPage, searchQuery, filter_project_progress_status_id],
    () => {
      refetchData();
    }
  );


  const fetchProgresses = (ctx, callback) => {
    store
      .dispatch("progress/fetchProgresses", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        // project_progress_status_id: filter_project_progress_status_id.value,
      })
      .then((response) => {
        const { progresses, total } = response.data;
        progresses.forEach(ele => ele.approve_status_id = ele.approve_status_id ? ele.approve_status_id : 1 )
        console.log('progresses',progresses)
        callback(progresses);
        totalRow.value = total;
        progressList.value = progresses
      })
      .catch((err) => {
        console.log(err);
        toast({
          component: ToastificationContent,
          props: {
            title: "獲取貸款清單時出錯",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };
  

  const projectOptions = ref([]);
  const productOptions = ref([]);
  const workerOptions = ref([]);
  const approvalStatusOptions = ref([]);

  const refetchOption = () => {
    store
      .dispatch("app/fetchOptionList", {
        projects: true,
        products: true,
        workers: true,
        approve_status: true,
      })
      .then((response) => {
        projectOptions.value = response.data.projects;
        productOptions.value = response.data.products;
        workerOptions.value = response.data.workers;
        approvalStatusOptions.value = response.data.approve_statuses;
      });
  };

  onMounted(() => {
    refetchOption();
  });

  return {
    fetchProgresses,
    tableColumns,
    perPage,
    currentPage,
    totalRow,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    progressList,
    refProgressListTable,
    ability,
    refetchData,
    projectOptions,
    productOptions,
    workerOptions,
    approvalStatusOptions,
    filter_project_progress_status_id
  };
}
